import * as actions from './actions';
import * as getters from './getters';

const mutations = {

};

const state = {
  updateProfileUrl: '/v1/user/update',
  deleteUrl: '/v1/user',
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
